<mat-card class="task">
  <mat-card-header>
    <mat-checkbox
      class="task-done"
      [(ngModel)]="task.done"
      (change)="status.emit(task)"
    ></mat-checkbox>
    <p class="task-label" [ngClass]="{ 'task-label-done': task.done }">
      {{ task.title }}
    </p>
    <button mat-icon-button class="btn-edit" (click)="edit.emit(task)">
        <mat-icon>edit</mat-icon>
      </button>
  </mat-card-header>
</mat-card>
